export enum Interval {
    HOUR = 'hour',
    DAY ='day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR ='year'
}
